import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Modal, FilledInput, Typography, Button, FormGroup, FormLabel, FormControl, Box, Grid, InputAdornment } from '@material-ui/core';
import dayjs from 'dayjs';

import themeColors from '../../assets/colors';
import { put } from '../../utils/api-services';
import helpers from '../../utils/helpers';
import AuthContext from '../../context';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: themeColors.background.default,
        padding: 20,
        width: '80%',
        borderRadius: 10
    },
    update: {
        marginLeft: 15,
        backgroundColor: '#0d6efd',
        borderColor: '#0d6efd',
        '&:hover': {
            backgroundColor: '#0d6efd',
            borderColor: '#0d6efd',
            boxShadow: 'none',
        }
    },
    bottom: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center'
    }
}));

const SalePriceEdit = ({ price, open, onClose }) => {

    const classes = useStyles();
    const { showToast, signOut, showLoader } = useContext(AuthContext);
    const [state, setState] = useState({
        idticket_sale_price: 0,
        date: dayjs().format('YYYY-MM-DD'),
        product: {},
        type: {},
        price: 0
    });

    useEffect(() => {
        setState(prev => ({
            ...prev,
            idticket_sale_price: price.idticket_sale_price,
            date: dayjs(price.date).format('YYYY-MM-DD'),
            product: price?.product_type_ref?.product,
            type: price?.product_type_ref?.type,
            price: price.price
        }));
    }, [price]);

    const handleChange = e => {
        const { name, value } = e.target;

        setState(prev => ({ ...prev, [name]: value }));
    }

    const validateForm = () => {
        const { idticket_sale_price, price } = state;

        (idticket_sale_price && price) ? update() : showToast('Price field is required', 'error');
    }

    const update = async () => {
        showLoader(true);
        const response = await put(`/ticketSalePrice/${state.idticket_sale_price}/update`, state);
        if (response.status === 200) {
            onClose(true);
            showToast(response.message);
        } else {
            console.log('[SalePriceEdit] update error', response);
            helpers.failRequest(response, showToast, signOut);
        }
        showLoader(false);
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            className={classes.root}
        >
            <div className={classes.container}>
                <Typography variant='h2'>{'Edit sale price'}</Typography>
                <Grid container>
                    <Grid item xs={6} lg={3}>
                        <FormGroup>
                            <FormLabel>{'Date'}</FormLabel>
                            <FormControl
                                variant='filled'
                                component={Box}
                                width='100%'
                            >
                                <FilledInput
                                    disabled
                                    type='text'
                                    placeholder='Date'
                                    name='date'
                                    value={state.date}
                                />
                            </FormControl>
                        </FormGroup>
                    </Grid>
                    <Grid item xs={6} lg={3}>
                        <FormGroup>
                            <FormLabel>{'Product'}</FormLabel>
                            <FormControl
                                variant='filled'
                                component={Box}
                                width='100%'
                            >
                                <FilledInput
                                    disabled
                                    type='text'
                                    placeholder='Product'
                                    name='product'
                                    value={state.product?.name}
                                />
                            </FormControl>
                        </FormGroup>
                    </Grid>
                    <Grid item xs={6} lg={3}>
                        <FormGroup>
                            <FormLabel>{'Type'}</FormLabel>
                            <FormControl
                                variant='filled'
                                component={Box}
                                width='100%'
                            >
                                <FilledInput
                                    disabled
                                    type='text'
                                    placeholder='Type'
                                    name='type'
                                    value={state.type?.name}
                                />
                            </FormControl>
                        </FormGroup>
                    </Grid>
                    <Grid item xs={6} lg={3}>
                        <FormGroup>
                            <FormLabel>{'Price'}</FormLabel>
                            <FormControl
                                variant='filled'
                                component={Box}
                                width='100%'
                            >
                                <FilledInput
                                    type='number'
                                    placeholder='Price'
                                    startAdornment={<InputAdornment position='start'>{'$'}</InputAdornment>}
                                    name='price'
                                    value={state.price}
                                    onChange={handleChange}
                                />
                            </FormControl>
                        </FormGroup>
                    </Grid>
                </Grid>
                <div className={classes.bottom}>
                    <Button
                        variant='contained'
                        color='secondary'
                        onClick={onClose}
                    >
                        {'Cancel'}
                    </Button>
                    <Button
                        variant='contained'
                        className={classes.update}
                        onClick={validateForm}
                    >
                        {'Update'}
                    </Button>
                </div>
            </div>
        </Modal>
    );
}

export default SalePriceEdit;